export const defaultCustomProps = {
  basePath: '',
};

export type AppCustomProps = typeof defaultCustomProps;
